"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.create = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageBodies_sidecar_1 = require("@voyage/entities/voyageBodies-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(crew, carryable, x, y, dx, dy) {
    assert_sidecar_1.assert.notNil(crew || carryable, 'need either a crew or carryable');
    var frame = sprites_sidecar_1.sprites.voyTileCrew[0];
    var scale = 2;
    var body = null;
    if (carryable) {
        if (carryable.image.fi) {
            frame = carryable.image.fi;
            scale = carryable.image.scale;
        }
        if (carryable.body) {
            body = carryable.body;
            carryable.body = null;
        }
    }
    // if (crew && crew.crewState) {
    //   body = crew.crewState.body
    // }
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrewItem, frame);
    image.scale = scale;
    if (carryable) {
        //console.log('set tint', image.tint, carryable.image.tint)
        image.tint = carryable.data.tint;
    }
    if (body) {
        image.visible = false;
    }
    // console.log('tint', image.tint)
    // spritesUtil.scale(image, scale)
    var obj = {
        id: common_1.createId(),
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        image: image,
        body: body,
        deathTimer: 0,
        x: x,
        y: y,
        dx: dx,
        dy: dy,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    obj.image.x = x;
    obj.image.y = y;
    if (obj.body) {
        voyageBodies_sidecar_1.voyageBodies.moveToXY(obj.body, x, y, false);
    }
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.image.destroy();
        if (c.body) {
            voyageBodies_sidecar_1.voyageBodies.kill(c.body);
        }
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDelta();
    if (obj.isDead) {
        return;
    }
    var speed = 200;
    obj.x += obj.dx * speed * ds;
    obj.y += obj.dy * speed * ds;
    moveToXY(obj, obj.x, obj.y);
    obj.deathTimer += ds;
    var deathTime = 2;
    if (obj.deathTimer >= deathTime) {
        kill(obj);
    }
}
